<template>
  <button
    :id="id"
    class="roomie-button-navigation"
    :aria-label="ariaLabel"
    :class="setClasses"
    :type="type"
    :disabled="disabled"
    @click="$emit('click')">
    <div class="roomie-button-navigation__icon pointer-events-none">
      <span class="roomie-icon">
        <slot />
      </span>
    </div>

    <span
      v-if="label"
      class="roomie-button-navigation__label">
      {{ label }}
    </span>
  </button>
</template>

<script>
export { SIZE, TYPE, VARIANT } from './utils'
import { SIZE, VARIANT, TYPE } from './utils'

export default {
  name: 'RoomieNavigationButton',
  props: {
    ariaLabel: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: TYPE.button,
      validator: (value) => Object.keys(TYPE).includes(value),
    },
    tabindex: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: SIZE.md,
      validator: (value) => Object.keys(SIZE).includes(value),
    },
    variant: {
      type: String,
      default: VARIANT.filled,
      validator: (value) => Object.keys(VARIANT).includes(value),
    },
    label: {
      type: String,
      default: ''
    },
    labelDirection: {
      type: String,
      default: 'right',
      validator: (value) => ['left', 'right'].includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  computed: {
    setClasses() {
      return {
        'roomie-button--sm' : this.size === 'sm',
        'roomie-button--md' : this.size === 'md',
        'roomie-button--lg' : this.size === 'lg',
        'roomie-button-navigation--filled' : this.variant === 'filled',
        'roomie-button-navigation--outlined' : this.variant === 'outlined',
        'roomie-button-navigation--ghost' : this.variant === 'ghost',
        'roomie-button-navigation--light' : this.variant === 'light',
        'roomie-button-navigation--dark' : this.variant === 'dark',
        'roomie-button-navigation--left-labeled' : this.label && this.labelDirection === 'left',
        'roomie-button-navigation--right-labeled' : this.label && this.labelDirection === 'right',
        'roomie-button-navigation--disabled' : this.disabled
      }
    }
  }
}
</script>

<style
  src="./_index.scss"
  lang="scss"/>
